<template>
  <div class="alsolike">
    <div class="h2">
      {{ $t("inventory.alsolike") }}
    </div>
    <div class="alsolike-list">
      <nuxt-link
        v-for="item in data?.data.randomInventory"
        :key="item?.steamid64"
        :to="localePath(`/inventory/${item?.steamid64}`)"
        class="alsolike-list_item btn btn-primary"
      >
        <img
          :alt="`${item?.persona_name} avatar`"
          :src="getImageFromProxy(item?.avatar_url?.replace(/\.(jpe?g)$/i, '_full.$1'), '100:100')"
          class="alsolike-list_item-avatar"
        >

        <p class="alsolike-list_item-name">
          {{ item?.persona_name }}
        </p>
        <UiPrice
          :decimal="0"
          :price="item?.total_value"
        />
        <i class="i-arrow rot_l f12" />
      </nuxt-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    market?: string
    steam64: string
  }>(),
  {
    market: 'waxpeer',
  },
);

const localePath = useLocalePath();

const { data, refresh } = await useAsyncData('randomInventory', () =>
  getRandomInventory({
    market_name: props.market,
    exclude_steamid64: props.steam64,
  }));

watch([() => props.market], () => {
  refresh();
});
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "/assets/scss/mixins" as *;

.alsolike {
  .h2 {
    font-size: 18px;
    font-weight: 800;
    margin-bottom: 24px;
    color: var(--surfaces-on-surface);
  }

  &-list {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &_item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 15px 20px;
      background: var(--surfaces-low-container);
      border-radius: 12px;
      gap: 12px;
      cursor: pointer;

      &:hover {
        background: color-mix(in srgb, var(--surfaces-low-container) 96%, white);
      }

      &-avatar {
        width: 40px;
        height: 40px;
        object-fit: cover;
        border-radius: 50%;
        display: flex;
      }

      &-name {
        flex-grow: 1;
        @include ellipsis;
      }

      .price {
        font-size: 16px;
        font-weight: 600;
        color: var(--surfaces-on-surface-variable);
      }
    }
  }
}
</style>
